import { ImageWrapper } from '../wrappers/ImageWrapper';
import image from '../../../assets/images/common/home-board-image.webp';

export default function HomeBoardImage() {
    return (
        <div className="home-board-image">
            <ImageWrapper src={image} alt="board" />
        </div>
    );
}
